import { MessageUnreadCount } from '@eih-netbroker/common';
import { useCallback } from 'react';
import { useNotification } from '../../../modules/message/services/useNotification';

export const useUserStreamMessage = () => {
  const { updateUnreadMessageCount } = useNotification();

  return useCallback(
    (message: MessageUnreadCount) => {
      updateUnreadMessageCount(Number(message.messageUnreadCount) ?? 0);
    },
    [updateUnreadMessageCount],
  );
};
